/* eslint-disable */
import * as ActionType from './types/CacheActionTypes';

export function cacheResponse(payload) {
  return {
    type: ActionType.CACHE_RESPONSE,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/CacheActions.js